import { SelectedMedia } from '@pletly/common';

export type ImageWithIndex = SelectedMedia & { mediaIndex: number };
export type BlurredImages = (ImageWithIndex | undefined)[];
